function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2e19bb8c\",\"scoped\":true,\"hasInlineConfig\":false}!postcss-loader?{\"sourceMap\":true,\"config\":{\"path\":\"/home/kss/proj/dn_source/config/postcss.config.js\"}}!sass-loader?{\"includePaths\":[\"/home/kss/proj/dn_source/src/sass/core\",\"/home/kss/proj/dn_source/src/sass\"],\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Subject.vue")
}
var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?presets[]=es2015,presets[]=stage-0!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Subject.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2e19bb8c\",\"hasScoped\":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Subject.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e19bb8c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/js/jikosaiten/index/components/Subject.vue
// module id = 907
// module chunks = 3